import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";
import { TableHead } from "./ui/table";

export const SortableHead = ({ label, active, dir, onClick, className = "", testid }) => {
  let Icon = ChevronsUpDown;
  if (active) Icon = dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <TableHead className={className}>
      <button
        type="button"
        data-testid={testid}
        onClick={onClick}
        className={`inline-flex items-center gap-1 whitespace-nowrap hover:text-[#1A1A1A] transition-colors ${active ? "text-[#1A1A1A] font-semibold" : ""}`}
      >
        {label} <Icon className="w-3.5 h-3.5 shrink-0" />
      </button>
    </TableHead>
  );
};

export const toggleSort = (prev, field) =>
  prev.field === field ? { field, dir: prev.dir === "asc" ? "desc" : "asc" } : { field, dir: "asc" };

export const sortRows = (rows, sort, accessors) => {
  if (!sort.field) return rows;
  const acc = accessors[sort.field];
  const mul = sort.dir === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const va = acc(a) ?? "";
    const vb = acc(b) ?? "";
    if (typeof va === "string" || typeof vb === "string") return String(va).localeCompare(String(vb)) * mul;
    return (va - vb) * mul;
  });
};
